// import DrugSearchBar from "components/drugSearchBar";

import Navbar from 'components/navbar';
import { Outlet } from 'react-router-dom';
import DrugSearchBar from 'screens/FactsScreen/components/drugSearchBar/DrugSearchBar';
import { useStore } from 'hooks/useStore';
import { useEffect } from 'react';

export const FactsScreenHOC = () => {
  const {
    FactsStore: { resetStore },
  } = useStore();

  useEffect(() => {
    // Cleanup function will be called when component unmounts
    return () => {
      resetStore();
    };
  }, [resetStore]);

  return (
    <div>
      <Navbar heading="Facts" searchComponent={<DrugSearchBar />} progressComponent={<></>} />
      <Outlet />
    </div>
  );
};
